

import React from 'react';
import { Link } from 'react-router-dom';

// Utility function to get the first name or a truncated version
const getPlayerDisplayName = (player) => {
    const name = player?.Name || 'Unknown';
    const parts = name.split(' ');
    return parts[0] || name.substring(0, 10);
};

export default function RunningCard({ runnig, user, winnAmount }) {
    // Determine if the current user is a participant to show the VIEW button
    const isParticipant =
        user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id;

    // Player Data
    const player1 = runnig.Created_by;
    const player2 = runnig.Accepetd_By;
    const gameAmount = runnig.Game_Ammount;
    const prizeAmount = gameAmount + winnAmount(gameAmount);

    return (
        <>
            <style>
                {`
                    @keyframes slideInLeft {
                        0% { transform: translateX(-100%); opacity: 0; }
                        100% { transform: translateX(0); opacity: 1; }
                    }

                    .running-card-premium {
                        animation: slideInLeft 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                        background: url('/images/test.avif') no-repeat center center;
                        background-size: cover;
                        border: 1px solid #1e252e;
                        border-radius: 8px;
                        margin-bottom: 10px;
                        overflow: hidden;
                        position: relative;
                        font-family: 'Inter', sans-serif;
                        width: 100%;
                        min-height: 85px;
                    }

                    /* Geometric pattern overlay */
                    .running-card-premium::before {
                        content: "";
                        position: absolute;
                        top: 0; right: 0;
                        width: 60px; height: 60px;
                        background: linear-gradient(135deg, transparent 60%, rgba(255,255,255,0.05) 40%);
                        z-index: 0;
                    }

                    .card-header-premium {
                        padding: 6px 14px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 1.5px solid rgba(255,255,255,0.1);
                        position: relative;
                        z-index: 1;
                        background: rgba(0,0,0,0.3);
                    }

                    .header-label-text {
                        color: #ffffff;
                        font-size: 11px;
                        font-weight: 600;
                        display: flex;
                        align-items: center;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .header-value-accent {
                        color: #76ff03; 
                        font-weight: 800;
                        margin-left: 5px;
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                    }

                    .card-body-premium {
                        display: grid;
                        grid-template-columns: 1.2fr 1fr 1.2fr;
                        padding: 10px 14px;
                        align-items: center;
                        position: relative;
                        z-index: 1;
                    }

                    .player-box {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }

                    .player-box.right-side {
                        flex-direction: row-reverse;
                        text-align: right;
                    }

                    .avatar-premium {
                        width: 38px;
                        height: 38px;
                        border-radius: 50%;
                        object-fit: cover;
                        background: #1e252e;
                        box-shadow: 0 0 8px rgba(0,0,0,0.5);
                    }
                    
                    /* High-contrast borders */
                    .p1-border { border: 2px solid #ff4500; }
                    .p2-border { border: 2px solid #00d215; }

                    .player-meta {
                        display: flex;
                        flex-direction: column;
                        overflow: hidden;
                    }

                    .player-name-val {
                        color: #ffffff;
                        font-size: 13px;
                        font-weight: 700;
                        white-space: nowrap;
                    }

                    .vs-action-box {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                    }

                    .vs-icon-small {
                        width: 26px;
                        filter: drop-shadow(0 0 5px rgba(255,255,255,0.3));
                    }

                    .btn-view-premium {
                        background: #007bff; /* Changed to Blue for distinct action */
                        color: #fff;
                        font-weight: 800;
                        border-radius: 4px;
                        padding: 3px 12px;
                        border: none;
                        font-size: 10px;
                        text-transform: uppercase;
                        cursor: pointer;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
                        transition: all 0.2s ease;
                    }

                    .btn-view-premium:hover {
                        background: #0056b3;
                        transform: translateY(-1px);
                    }

                    .btn-view-premium:active {
                        transform: scale(0.92);
                    }

                    .coin-mini {
                        width: 14px;
                        height: 14px;
                        margin-right: 3px;
                    }
                `}
            </style>

            <div className="running-card-premium">
                {/* Header Row */}
                <div className="card-header-premium">
                    <div className="header-label-text">
                        Entry:
                        <span className="header-value-accent">
                            <img src="/images/indiarupee.png" className="coin-mini" alt="coin" />
                            {gameAmount}
                        </span>
                    </div>
                    <div className="header-label-text">
                        Prize:
                        <span className="header-value-accent">
                            <img src="/images/indiarupee.png" className="coin-mini" alt="coin" />
                            {prizeAmount}
                        </span>
                    </div>
                </div>

                {/* Main Body */}
                <div className="card-body-premium">
                    {/* Player 1 (Host) */}
                    <div className="player-box">
                        <img
                            src={player1?.Avatar ? `https://api.kakaking.in/${player1.Avatar}` : "/images/avatars/Avatar2.png"}
                            alt="P1"
                            className="avatar-premium p1-border"
                            onError={(e) => (e.target.src = "/images/avatars/Avatar2.png")}
                        />
                        <div className="player-meta">
                            <span className="player-name-val">{getPlayerDisplayName(player1)}</span>
                        </div>
                    </div>

                    {/* VS & View Button */}
                    <div className="vs-action-box">
                        <img src='/images/VS.png' className='vs-icon-small' alt="vs" />

                        {isParticipant && (
                            <Link
                                to={{
                                    pathname: `/viewgame1/${runnig._id}`,
                                    state: { prevPath: window.location.pathname },
                                }}
                                style={{ textDecoration: 'none' }}
                            >
                                <button className="btn-view-premium">VIEW</button>
                            </Link>
                        )}
                    </div>

                    {/* Player 2 (Opponent) */}
                    <div className="player-box right-side">
                        <img
                            src={player2?.Avatar ? `https://api.kakaking.in/${player2.Avatar}` : "/images/avatars/Avatar3.png"}
                            alt="P2"
                            className="avatar-premium p2-border"
                            onError={(e) => (e.target.src = "/images/avatars/Avatar3.png")}
                        />
                        <div className="player-meta">
                            <span className="player-name-val">{getPlayerDisplayName(player2)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}